// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_nzIFZ","avatar":"index_avatar_dczD_","menuIcon":"index_menuIcon_XMyZu"};